import ApiBaseURLProps from "../other/apiBaseURL";
import axios from "axios";
import { authorizationHeader, postAxios } from "./apiConfig";
import { setTypesOfBusinessOfCompany } from "../../redux/companySlice";
import {
  filterCompanyDocument,
  filterDocument,
  filterPersonDocument,
  mapDocument,
} from "../kyc/documentDetails";


export function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

class KycSaveApiService {
  getCompanyDetail(data) {
    const companyDetails = data.companyDetails;
    const directorDetails = data.directorDetails.directorDetailsList;
    const locationType = data.addressDetails.locationType;
    let nDirectorDeatilList = [];
    for (let i = 0; i < directorDetails.length; i++) {
      const addressDetailList = [];

      if (directorDetails[i].paop && directorDetails[i].paop !== "N") {
        addressDetailList.push({
          id: directorDetails[i].paid,
          addressTypeId: 2,
          countryCd: directorDetails[i].country,
          stateCd: directorDetails[i].state,
          districtCd: directorDetails[i].district,
          municipalityCd: directorDetails[i].municipality,
          ward: directorDetails[i].ward,
          tole: directorDetails[i].tole,
          blockNo: directorDetails[i].blockNo,
          phoneNo: directorDetails[i].telephoneNo,
          email: directorDetails[i].emailId,
          mobileNo: directorDetails[i].mobileNo,
          op: directorDetails[i].paid ? directorDetails[i].paop : "I",
        });
      }

      if (directorDetails[i].ppaop && directorDetails[i].ppaop !== "N") {
        addressDetailList.push({
          id: directorDetails[i].ppaid,
          op: directorDetails[i].ppaid ? directorDetails[i].ppaop : "I",
          addressTypeId: 1,
          countryCd: directorDetails[i].perCountry,
          stateCd: directorDetails[i].perState,
          districtCd: directorDetails[i].perDistrict,
          municipalityCd: directorDetails[i].perMunicipality,
          ward: directorDetails[i].perWard,
          tole: directorDetails[i].perTole,
          blockNo: directorDetails[i].perBlockNo,
          hasPermanentAddressSame: directorDetails[i].hasPermanentAddressSame,
          phoneNo: directorDetails[i].perTelephoneNo,
        });
      }

      const familyDetailList = [];
      console.log("familyDetailList");

      const pushFamily = (f) => {
        if (!f.personDetail.op || f.personDetail.op === "N") return;

        f.personDetail.op = f.personDetail.id ? f.personDetail.op : "I";
        f.op = f.id ? "N" : "I";

        familyDetailList.push(f);
      };

      pushFamily({
        id: directorDetails[i].pfid,
        relationTypeId: "F",
        personDetail: {
          id: directorDetails[i].pfpid,
          op: directorDetails[i].pfpop,
          fname: directorDetails[i].fatherFirstName,
          mname: directorDetails[i].fatherMiddleName,
          lname: directorDetails[i].fatherLastName,
        },
      });

      pushFamily({
        id: directorDetails[i].pgfid,
        relationTypeId: "GF",
        personDetail: {
          id: directorDetails[i].pgfpid,
          op: directorDetails[i].pgfpop,
          fname: directorDetails[i].grandFatherFirstName,
          mname: directorDetails[i].grandFatherMiddleName,
          lname: directorDetails[i].grandFatherLastName,
        },
      });

      pushFamily({
        id: directorDetails[i].pspid,
        relationTypeId: "SP",
        personDetail: {
          id: directorDetails[i].psppid,
          op: directorDetails[i].psppop,
          fname: directorDetails[i].spouseFirstName,
          mname: directorDetails[i].spouseMiddleName,
          lname: directorDetails[i].spouseLastName,
        },
      });

      const pDocumentDetailList = directorDetails[i].documentList
        .filter((p) => p.op === "U")
        .map(mapDocument);

      let personDetail =
        directorDetails[i].pop !== "N"
          ? {
            id: directorDetails[i].id,
            fname: directorDetails[i].firstName,
            mname: directorDetails[i].middleName,
            lname: directorDetails[i].lastName,
            op: directorDetails[i].id ? directorDetails[i].pop : "I",
            pan: directorDetails[i].panNo,
          }
          : {
            id: directorDetails[i].id,
            op: "N",
          };

      personDetail.addressDetailList = addressDetailList;
      personDetail.familyDetailList = familyDetailList;
      personDetail.personDocumentDetailList = pDocumentDetailList;

      if (
        (!personDetail.addressDetailList ||
          !personDetail.addressDetailList.length) &&
        (!personDetail.familyDetailList ||
          !personDetail.familyDetailList.length) &&
        (!personDetail.personDocumentDetailList ||
          !personDetail.personDocumentDetailList.length) &&
        personDetail.op === "N"
      ) {
        personDetail = null;
      }

      const director = {
        id: directorDetails[i].id,
        isAuthorized: directorDetails[i].authorizedPerson,
        directorTypeId: directorDetails[i].type,
        directorTypeOthers: directorDetails[i].directorTypeOthers,
        designation: directorDetails[i].designation,
        isContactPerson: directorDetails[i].isContactPerson,
        isPrimaryContactPerson: directorDetails[i].isPrimaryContactPerson,
        isDirector: directorDetails[i].isDirector,
        designationOthers: directorDetails[i].designationOthers,
        personDetail,
        op: directorDetails[i].id ? directorDetails[i].op : "I",
      };

      if (director.personDetail || director.op !== "N")
        nDirectorDeatilList.push(director);
    }

    for (let i = 0; i < data.directorDetails.rList.length; i++) {
      nDirectorDeatilList.push({
        id: data.directorDetails.rList[i],
        op: "D",
      });
    }

    const countryOfRegistration = data.companyDetails.countryOfRegistration;
    const companyDocumentDetailList = data.documentDetails.documentList
      .filter((p) => p.op === "U" && filterCompanyDocument(p, { locationType }))
      .map(mapDocument);

    data.documentDetails.documentList
      .filter((p) => p.id && !filterCompanyDocument(p, { locationType }))
      .forEach((p) => {
        companyDocumentDetailList.push({ id: p.id, op: "D" });
      });

    data.documentDetails.rList.forEach((doc) => {
      companyDocumentDetailList.push({ id: doc, op: "D" });
    });

    const addressDetails = data.addressDetails;

    const addressDetailList = [];
    if (addressDetails.op === "U") {
      addressDetailList.push({
        id: addressDetails.id,
        addressTypeId: 2,
        countryCd: addressDetails.country,
        stateCd: addressDetails.state,
        districtCd: addressDetails.district,
        municipalityCd: addressDetails.municipality,
        ward: addressDetails.ward,
        tole: addressDetails.tole,
        blockNo: addressDetails.blockNo,
        phoneNo: addressDetails.telephoneNo,
        email: addressDetails.emailId,
        mobileNo: addressDetails.mobileNo,
        website: addressDetails.website,
        lat:
          addressDetails.LatLng &&
          addressDetails.LatLng.mapPosition &&
          addressDetails.LatLng.mapPosition.lat,
        lng:
          addressDetails.LatLng &&
          addressDetails.LatLng.mapPosition &&
          addressDetails.LatLng.mapPosition.lng,
        op: addressDetails.id ? "U" : "I",
      });
    }
    if (addressDetails.pop === "U") {
      addressDetailList.push({
        id: addressDetails.pid,
        addressTypeId: 1,
        countryCd: addressDetails.perCountry,
        stateCd: addressDetails.perState,
        districtCd: addressDetails.perDistrict,
        municipalityCd: addressDetails.perMunicipality,
        ward: addressDetails.perWard,
        tole: addressDetails.perTole,
        blockNo: addressDetails.perBlockNo,
        phoneNo: addressDetails.perTelephoneNo,
        hasPermanentAddressSame: addressDetails.hasPermanentAddressSame,
        op: addressDetails.pid ? "U" : "I",
      });
    }

    const biometricsList = data.biometricsDetailsList;
    let biometricsDetailsList = null;

    if ((biometricsList.op && biometricsList.op !== "N") || (biometricsList.sop && biometricsList.sop !== "N") || (biometricsList.staop && biometricsList.staop !== "N"))
      biometricsDetailsList = biometricsList;


    let companyDetail = {
      id: companyDetails.id,
      directorDetailList: nDirectorDeatilList,
      documentDetailList: companyDocumentDetailList,
      biometricsDetailsList: biometricsDetailsList,
      addressDetailList,
      op: "N",
    };
    if (companyDetails.op === "U")
      companyDetail = {
        ...companyDetail,
        name: companyDetails.companyName,
        ceoFirstName: companyDetails.ceoFirstName,
        ceoMiddleName: companyDetails.ceoMiddleName,
        ceoLastName: companyDetails.ceoLastName,
        secretaryFirstName: companyDetails.secFirstName,
        secretaryMiddleName: companyDetails.secMiddleName,
        secretaryLastName: companyDetails.secLastName,
        companyTypeCd: companyDetails.companyType,
        registrationDate: companyDetails.registrationDate,
        //  pan: companyDetails.panNo,
        dateOfIncop: companyDetails.incorporationDate,
        countryCd: companyDetails.countryOfRegistration,
        regOffice: companyDetails.registrationOffice,
        regNo: companyDetails.registrationNo,
        //  vatRegNo: companyDetails.panVatRegistrationNo,
        pan: companyDetails.panVatRegistrationNo,
        hasPan: companyDetails.hasPan,
        vatPanRegDate: companyDetails.registrationDate,
        bussinessTypeId: companyDetails.typesOfBusinessOfCompany,
        areaOfWork: companyDetails.areaOfWork,
        headOfficeName: companyDetails.nameAddressOfCompany,
        isListed: companyDetails.isListed,
        listingDate: companyDetails.listingDate,
        op: companyDetails.id ? companyDetails.op : "I",
        comapnyTypeOthers: companyDetails.companyTypeOthers,
        businessTypeOthers: companyDetails.businessTypeOthers,
        dateOfIncopBs: companyDetails.incorporationDateBs,
        registrationDateBs: companyDetails.registrationDateBs,
        listingDateBs: companyDetails.listingDateBs,
        isSubsidiary: companyDetails.isSubsidiary,
        regDistrict: companyDetails.regDistrict,
        panEximption: companyDetails.panEximption,

      };

    return companyDetail;
  }

  getPersonalDetails(data) {
    const personalDetails = data.personalDetails;
    const occupationDetails = data.occupationDetails;
    const moneyLaunderingDetails = { ...data.moneyLaunderingDetails };
    let guardianDetails = null;
    const addressDetails = data.addressDetails;
    const familyDetails = data.familyDetails.relativeList;

    let personDetails = {};

    if (personalDetails.op !== "N") {
      personDetails = {
        id: personalDetails.id,
        fname: personalDetails.firstName,
        mname: personalDetails.middleName,
        lname: personalDetails.lastName,
        fnameNep: personalDetails.firstNameNep,
        mnameNep: personalDetails.middleNameNep,
        lnameNep: personalDetails.lastNameNep,
        gender: personalDetails.gender,
        dob: personalDetails.dob,
        dobBs: personalDetails.dobBs,
        countryCd: personalDetails.nationality,
        pan: personalDetails.pan,
        isMinor: personalDetails.isMinor,
        isNrn: personalDetails.isNrn,
        isDisabled: personalDetails.isDisabled,
        maritalStatus: personalDetails.maritalStatus,
        documentForMinor: personalDetails.documentForMinor,
        op: personalDetails.id ? "U" : "I",
      };
    } else {
      personDetails = {
        id: personalDetails.id,
        op: personalDetails.id ? "N" : "I",
      };
    }

    let nFamilyList = [];
    console.log("family details test", familyDetails);
    for (let i = 0; i < familyDetails.length; i++) {
      if (familyDetails[i].op === "U" || familyDetails[i].pop === "U") {
        if (
          familyDetails[i].firstName ||
          familyDetails[i].middleName ||
          familyDetails[i].lastName
        )
          nFamilyList.push({
            id: familyDetails[i].id,
            relationTypeId: familyDetails[i].relativeTypeId,
            op: familyDetails[i].id ? familyDetails[i].op : "I",
            personDetail: {
              id: familyDetails[i].pid,
              fname: familyDetails[i].firstName,
              mname: familyDetails[i].middleName,
              lname: familyDetails[i].lastName,
              fnameNep: familyDetails[i].firstNameNep,
              mnameNep: familyDetails[i].middleNameNep,
              lnameNep: familyDetails[i].lastNameNep,
              op: familyDetails[i].pid ? familyDetails[i].pop : "I",
            },
          });
        else if (familyDetails[i].id) {
          nFamilyList.push({
            id: familyDetails[i].id,
            op: "D",
            personDetail: {
              id: familyDetails[i].pid,
              op: "D",
            },
          });
        }
      }
    }

    data.familyDetails.rList.forEach((doc) => {
      nFamilyList.push({ id: doc, op: "D" });
    });

    const isMinor = personalDetails.isMinor;
    const isNrn = personalDetails.isNrn;
    const gender = personalDetails.gender;
    const nationality = personalDetails.nationality;
    const documentForMinor = personalDetails.documentForMinor;

    const locationType = data.addressDetails.locationType;
    const personDocumentDetailList = data.documentDetails.documentList
      .filter(
        (p) =>
          p.op === "U" &&
          filterDocument(p, {
            nationality,
            isMinor,
            isNrn,
            documentForMinor,
            locationType,
          })
      )
      .map(mapDocument);

    data.documentDetails.documentList
      .filter(
        (p) =>
          p.id &&
          !filterDocument(p, {
            nationality,
            isMinor,
            isNrn,
            documentForMinor,
            locationType,
          })
      )
      .forEach((p) => {
        personDocumentDetailList.push({ id: p.id, op: "D" });
      });

    data.documentDetails.rList.forEach((doc) => {
      personDocumentDetailList.push({ id: doc, op: "D" });
    });

    const addressDetailList = [];
    if (addressDetails.pop === "U") {
      addressDetailList.push({
        id: addressDetails.pid,
        addressTypeId: 1,
        countryCd: addressDetails.perCountry,
        stateCd: addressDetails.perState,
        districtCd: addressDetails.perDistrict,
        municipalityCd: addressDetails.perMunicipality,
        ward: addressDetails.perWard,
        tole: addressDetails.perTole,
        blockNo: addressDetails.perBlockNo,
        phoneNo: addressDetails.perTelephoneNo,
        hasPermanentAddressSame: addressDetails.hasPermanentAddressSame,
        op: addressDetails.pid ? "U" : "I",
      });
    }

    if (addressDetails.op === "U") {
      addressDetailList.push({
        id: addressDetails.id,
        addressTypeId: 2,
        countryCd: addressDetails.country,
        stateCd: addressDetails.state,
        districtCd: addressDetails.district,
        municipalityCd: addressDetails.municipality,
        ward: addressDetails.ward,
        tole: addressDetails.tole,
        blockNo: addressDetails.blockNo,
        phoneNo: addressDetails.telephoneNo,
        email: addressDetails.emailId,
        mobileNo: addressDetails.mobileNo,
        lat:
          addressDetails.LatLng &&
          addressDetails.LatLng.mapPosition &&
          addressDetails.LatLng.mapPosition.lat,
        lng:
          addressDetails.LatLng &&
          addressDetails.LatLng.mapPosition &&
          addressDetails.LatLng.mapPosition.lng,
        op: addressDetails.id ? "U" : "I",
      });
    }

    const occupationDetailList = [];

    if (
      occupationDetails.op === "U" ||
      occupationDetails.companyDetailsList.find((c) => c.op !== "N") ||
      occupationDetails.companyRelationDetailsList.find((c) => c.op !== "N") ||
      occupationDetails.rConpanyList.length ||
      occupationDetails.rCompanyRelationList.length
    ) {
      if (occupationDetails.op === "U") {
        occupationDetailList.push({
          id: occupationDetails.id,
          financialStatus: occupationDetails.financialDetails,
          designation: occupationDetails.designation,
          address: occupationDetails.address,
          orgName: occupationDetails.organizationName,
          occupationTypeId: occupationDetails.occupationType,
          businessTypeId: occupationDetails.businessType,
          idNo: occupationDetails.docId,
          op: occupationDetails.id ? "U" : "I",
          occupationTypeOthers: occupationDetails.occupationTypeOthers,
          businessTypeOthers: occupationDetails.businessTypeOthers,
        });
      } else {
        occupationDetailList.push({
          id: occupationDetails.id,
          op: "N",
        });
      }

      if (occupationDetailList[0] && occupationDetailList[0].id)
        occupationDetailList[0].investmentCompanyList =
          occupationDetails.companyDetailsList
            .filter((c) => c.op !== "N")
            .map((companyDetails) => ({
              id: companyDetails.id,
              name: companyDetails.companyName,
              designation: companyDetails.companyDesignation,
              designationOthers: companyDetails.designationOthers,
              op: companyDetails.op,
            }));

      for (let i = 0; i < occupationDetails.rConpanyList.length; i++) {
        occupationDetailList[0].investmentCompanyList.push({
          id: occupationDetails.rConpanyList[i],
          op: "D",
        });
      }

      if (occupationDetailList[0] && occupationDetailList[0].id)
        occupationDetailList[0].investmentCompanyRelationList =
          occupationDetails.companyRelationDetailsList
            .filter((c) => c.op !== "N")
            .map((companyDetails) => ({
              name: companyDetails.companyNameOrRelation,
              orgName: companyDetails.companyNameRelation,
              designation: companyDetails.companyRelationDesignation,
              designationOthers: companyDetails.designationOthers,
              dataFrom: companyDetails.fromAd,
              dataTo: companyDetails.toAd,
              op: companyDetails.op,
            }));


      for (let i = 0; i < occupationDetails.rCompanyRelationList.length; i++) {
        occupationDetailList[0].investmentCompanyRelationList.push({
          id: occupationDetails.rCompanyRelationList[i],
          op: "D",
        });
      }
    }

    const antiMoneyLaunderingList = [];
    if (moneyLaunderingDetails.op === "U") {
      delete moneyLaunderingDetails.errors;
      antiMoneyLaunderingList.push({
        ...moneyLaunderingDetails
      });
    }
    if (
      personalDetails.isMinor &&
      (data.guardianDetails.paop === "U" ||
        data.guardianDetails.pop === "U" ||
        data.guardianDetails.op === "U" ||
        data.guardianDetails.guardianDocumentList.find((p) => p.op === "U")) ||
      data.guardianDetails.gsop === 'I'
    ) {
      const guardianDocumentList = data.guardianDetails.guardianDocumentList
        .filter((p) => p.op === "U")
        .map(mapDocument);
      let biometricsDetailsList = null;
      if (data.guardianDetails.gsop != 'N') {
        biometricsDetailsList =
        {
          signature: data.guardianDetails.signature,
          sop: data.guardianDetails.gsop
        }
      }
      guardianDetails = {
        id: data.guardianDetails.id,
        op: data.guardianDetails.id ? "N" : "I",
        personDetail: {
          id: data.guardianDetails.pid,
          addressDetailList: [],
          op: data.guardianDetails.pid ? "N" : "I",
          personDocumentDetailList: guardianDocumentList,
          biometricsDetailsList: biometricsDetailsList,
          pan: data.guardianDetails.pan,
          fnameNep: data.guardianDetails.firstNameNep,
          mnameNep: data.guardianDetails.middleNameNep,
          lnameNep: data.guardianDetails.lastNameNep,
        },
      };

      if (data.guardianDetails.paop === "U") {
        guardianDetails.personDetail.addressDetailList.push({
          id: data.guardianDetails.paid,
          addressTypeId: 3,
          countryCd: data.guardianDetails.country,
          stateCd: data.guardianDetails.state,
          districtCd: data.guardianDetails.district,
          municipalityCd: data.guardianDetails.municipality,
          ward: data.guardianDetails.ward,
          tole: data.guardianDetails.tole,
          blockNo: data.guardianDetails.blockNo,
          phoneNo: data.guardianDetails.telephoneNo,
          email: data.guardianDetails.emailId,
          mobileNo: data.guardianDetails.mobileNo,
          fax: data.guardianDetails.fax,
          op: data.guardianDetails.paid ? "U" : "I",
        });
      }

      if (data.guardianDetails.pop === "U") {
        guardianDetails.personDetail.fname = data.guardianDetails.firstName;
        guardianDetails.personDetail.mname = data.guardianDetails.middleName;
        guardianDetails.personDetail.lname = data.guardianDetails.lastName;
        guardianDetails.personDetail.op = data.guardianDetails.pid ? "U" : "I";
      }

      if (data.guardianDetails.op === "U") {
        guardianDetails.relationTypeId = data.guardianDetails.relationship;
        guardianDetails.relationTypeOthers =
          data.guardianDetails.relationshipOthers;
        guardianDetails.op = data.guardianDetails.id ? "U" : "I";
      }
    } else if (
      !personalDetails.isMinor &&
      guardianDetails &&
      guardianDetails.id
    ) {
      guardianDetails = {
        id: guardianDetails.id,
        op: "D",
      };
    }

    personDetails = {
      ...personDetails,
      addressDetailList: addressDetailList,
      occupationDetailList: occupationDetailList,
      antiMoneyLaunderingList: antiMoneyLaunderingList,
      guardianDetail: guardianDetails,
      familyDetailList: nFamilyList,
      personDocumentDetailList,
    };

    const biometricsList = data.biometricsDetailsList;
    let biometricsDetailsList = null;

    if ((biometricsList.op && biometricsList.op !== "N") || (biometricsList.sop && biometricsList.sop !== "N") || (biometricsList.staop && biometricsList.staop !== "N"))
      biometricsDetailsList = biometricsList;
    personDetails = {
      ...personDetails,
      addressDetailList: addressDetailList,
      occupationDetailList: occupationDetailList,
      guardianDetail: guardianDetails,
      familyDetailList: nFamilyList,
      biometricsDetailsList: biometricsDetailsList,

      personDocumentDetailList,
    };

    return personDetails;
  }


  changeDp(dpId) {
    return postAxios(
      ApiBaseURLProps.apiBaseURL + "/security/changeDpId?dpId=" + dpId,
      null,
      {
        ...authorizationHeader(),
      }
    );
  }
  savePersonalDetails(data) {
    const boidList = data.boidDetails.boidList;
    const bankDetails = data.bankDetails.bankDetailsList;

    console.log(data);
    const dynamicDataList = Object.values(
      data.dynamicFieldDetails.allDynamicField
    )
      .filter((d) => d.op && d.op !== "N")
      .map((d) => ({
        dynamicKey: d.dynamicKey,
        value: d.value,
        op: d.value ? "I" : "D",
      }));

    let nBoidList = [];


    let dpId;

    try {
      const user = parseJwt(sessionStorage.getItem("access_token"));
      dpId = user.dpId;
    } catch (e) {

    }

    let isForBoid;
    let isForMeroShareId;
    // let isForMeroShareId = isForBoid ? (data.boidDetails?.createMeroShareId ?? null) : undefined;

    for (let i = 0; i < boidList.length; i++) {
      if (!dpId && boidList[i].isForwarded) {
        dpId = boidList[i].dpId;
      }
      if (boidList[i].op !== "N")
        nBoidList.push({
          id: boidList[i].id,
          boId: boidList[i].boid,
          dpId: boidList[i].dpId,
          isForwarded: boidList[i].dpId == dpId,
          op: boidList[i].id ? "U" : "I",
        });
    }

    for (let i = 0; i < data.boidDetails.rList.length; i++) {
      nBoidList.push({
        id: data.boidDetails.rList[i],
        op: "D",
      });
    }

    if (!data.boidDetails.hasBoid) {
      for (let i = 0; i < boidList.length; i++) {
        nBoidList.push({
          id: boidList[i].id,
          op: "D",
        });
      }

      if (!dpId)
        dpId = data.boidDetails.fdpId;
    }
    isForBoid = data.boidDetails.createBoid;
    isForMeroShareId = isForBoid ? (data.boidDetails?.createMeroShareId ?? null) : undefined;
    // let addressDetail = {
    //   ...data.addressDetails,
    //   lat: data.addressDetails.LatLng.mapPosition.lat,
    //   lng: data.addressDetails.LatLng.mapPosition.lng,
    // };

    let nBankAccountDeatilList = [];
    for (let i = 0; i < bankDetails.length; i++) {
      if (bankDetails[i].op !== "N")
        nBankAccountDeatilList.push({
          id: bankDetails[i].id,
          accountNo: bankDetails[i].bankAccountNumber,
          accountType: bankDetails[i].typesOfBankAccount,
          bankId: bankDetails[i].bank,
          op: bankDetails[i].id ? "U" : "I",
          isPrimaryAccount: bankDetails[i].isPrimaryAccount,
          bankBranchCd: bankDetails[i].bankBranch,
        });
    }

    for (let i = 0; i < data.bankDetails.rList.length; i++) {
      nBankAccountDeatilList.push({
        id: data.bankDetails.rList[i],
        op: "D",
      });
    }

    const postData = {
      id: data.routerData.customerId,
      isForBoid,
      dpId,
      bankAccountDetailList: nBankAccountDeatilList,
      boIdList: nBoidList,
      dynamicDataList,
      extraData: data.extraData
    };
    // Only add `isForMeroShareId` if it's explicitly `true` or `false`
    if (isForMeroShareId !== undefined) {
      postData.isForMeroShareId = isForMeroShareId;
    }

    if (data.routerData.formType === "C") {
      postData.type = "C";
      postData.companyDetail = this.getCompanyDetail(data);
    } else {
      postData.type = "I";
      postData.personDetail = this.getPersonalDetails(data);
    }
    console.log("postData", postData);
    return postAxios(ApiBaseURLProps.apiBaseURL + "/kyc/save", postData, {
      ...authorizationHeader(),
    });
  }

  submitPersonalDetails(forwardType, customerDto, messsages) {
    const dtoOnly = this.getObjectBeforeSavePersonalDetails(customerDto);
    const payload = {
      customerDto: dtoOnly,
      messages: messsages || []
    };
    return postAxios(ApiBaseURLProps.apiBaseURL + "/kyc/submit?type=" + forwardType,
      payload, {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    });
  }
  getObjectBeforeSavePersonalDetails(data) {

    const boidList = data.boidDetails.boidList;
    const bankDetails = data.bankDetails.bankDetailsList;

    console.log(data);
    const dynamicDataList = Object.values(
      data.dynamicFieldDetails.allDynamicField
    )
      .filter((d) => d.op && d.op !== "N")
      .map((d) => ({
        dynamicKey: d.dynamicKey,
        value: d.value,
        op: d.value ? "I" : "D",
      }));

    let nBoidList = [];


    let dpId;

    try {
      const user = parseJwt(sessionStorage.getItem("access_token"));
      dpId = user.dpId;
    } catch (e) {

    }

    let isForBoid;
    let isForMeroShareId;
    // let isForMeroShareId = isForBoid ? (data.boidDetails?.createMeroShareId ?? null) : undefined;

    for (let i = 0; i < boidList.length; i++) {
      if (!dpId && boidList[i].isForwarded) {
        dpId = boidList[i].dpId;
      }
      if (boidList[i].op !== "N")
        nBoidList.push({
          id: boidList[i].id,
          boId: boidList[i].boid,
          dpId: boidList[i].dpId,
          isForwarded: boidList[i].dpId == dpId,
          op: boidList[i].id ? "U" : "I",
        });
    }

    for (let i = 0; i < data.boidDetails.rList.length; i++) {
      nBoidList.push({
        id: data.boidDetails.rList[i],
        op: "D",
      });
    }

    if (!data.boidDetails.hasBoid) {
      for (let i = 0; i < boidList.length; i++) {
        nBoidList.push({
          id: boidList[i].id,
          op: "D",
        });
      }

      if (!dpId)
        dpId = data.boidDetails.fdpId;
    }
    isForBoid = data.boidDetails.createBoid;
    isForMeroShareId = isForBoid ? (data.boidDetails?.createMeroShareId ?? null) : undefined;
    // let addressDetail = {
    //   ...data.addressDetails,
    //   lat: data.addressDetails.LatLng.mapPosition.lat,
    //   lng: data.addressDetails.LatLng.mapPosition.lng,
    // };

    let nBankAccountDeatilList = [];
    for (let i = 0; i < bankDetails.length; i++) {
      if (bankDetails[i].op !== "N")
        nBankAccountDeatilList.push({
          id: bankDetails[i].id,
          accountNo: bankDetails[i].bankAccountNumber,
          accountType: bankDetails[i].typesOfBankAccount,
          bankId: bankDetails[i].bank,
          op: bankDetails[i].id ? "U" : "I",
          isPrimaryAccount: bankDetails[i].isPrimaryAccount,
          bankBranchCd: bankDetails[i].bankBranch,
        });
    }

    for (let i = 0; i < data.bankDetails.rList.length; i++) {
      nBankAccountDeatilList.push({
        id: data.bankDetails.rList[i],
        op: "D",
      });
    }

    const postData = {
      id: data.routerData.customerId,
      isForBoid,
      dpId,
      bankAccountDetailList: nBankAccountDeatilList,
      boIdList: nBoidList,
      dynamicDataList,
      extraData: data.extraData
    };
    // Only add `isForMeroShareId` if it's explicitly `true` or `false`
    if (isForMeroShareId !== undefined) {
      postData.isForMeroShareId = isForMeroShareId;
    }

    if (data.routerData.formType === "C") {
      postData.type = "C";
      postData.companyDetail = this.getCompanyDetail(data);
    } else {
      postData.type = "I";
      postData.personDetail = this.getPersonalDetails(data);
    }
    console.log("postData", postData);
    return postData;
  }
}

export default new KycSaveApiService();
